import { render, staticRenderFns } from "./PontoEletronico.vue?vue&type=template&id=3f868e60"
import script from "./PontoEletronico.vue?vue&type=script&lang=js"
export * from "./PontoEletronico.vue?vue&type=script&lang=js"
import style0 from "./PontoEletronico.vue?vue&type=style&index=0&id=3f868e60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports